import { BASEURL } from "../BaseUrl";

/**
 * Creates a new schedule processor with the provided data.
 * @param {Object} axios - The Axios instance to use for the request.
 * @param {Object} data - The data to create the schedule processor.
 * @returns {Promise} - A Promise that resolves with the response from the API.
 */
const createScheduleProcessor = async (axios, data) => {
  return await axios.post(`${BASEURL}/schedule/create-schedule`, data, {});
};

/**
 * Updates an existing schedule processor with the provided data.
 * @param {Object} axios - The Axios instance to use for the request.
 * @param {Object} data - The data to update the schedule processor.
 * @returns {Promise} - A Promise that resolves with the response from the API.
 */
const updateScheduleProcessor = async (axios, data) => {
  return await axios.post(`${BASEURL}/schedule/update-schedule`, data, {});
};

/**
 * Fetches the schedule data based on workflow ID and type.
 * @param {Object} axios - The Axios instance to use for the request.
 * @param {Object} data - The parameters to fetch the schedule data.
 * @param {string} data.workflow_id - The ID of the workflow to fetch the schedule for.
 * @param {string} data.workflow_type - The type of workflow to fetch the schedule for.
 * @returns {Promise} - A Promise that resolves with the response from the API.
 */
const getCronData = async (axios, data) => {
  return await axios.get(`${BASEURL}/schedule/get-schedule`, {
    params: {
      workflow_id: data.workflow_id,
      workflow_type: data.workflow_type,
    },
  });
};

/**
 * Deletes a specific schedule processor based on workflow ID and type.
 * @param {Object} axios - The Axios instance to use for the request.
 * @param {Object} data - The parameters to delete the schedule processor.
 * @param {string} data.workflow_id - The ID of the workflow associated with the schedule to be deleted.
 * @param {string} data.workflow_type - The type of workflow associated with the schedule to be deleted.
 * @returns {Promise} - A Promise that resolves with the response from the API.
 */
const deleteScheduleProcessor = async (axios, data) => {
  return await axios.delete(`${BASEURL}/schedule/delete-schedule`, {
    params: {
      workflow_id: data.workflow_id,
      workflow_type: data.workflow_type,
    },
  });
};

export const ScheduleApi = {
  createScheduleProcessor,
  updateScheduleProcessor,
  getCronData,
  deleteScheduleProcessor,
};
